function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Button from '../Button/Button';
import styles from './IconButton.module.scss';
import ButtonWrapper from '../ButtonWrapper/ButtonWrapper';
/**
 * Icon button container.
 *
 * @param {object} props React component properties
 * @param {string} props.className custom CSS classes to add
 * @param {boolean} props.disabled affects style and prevents onClick handler
 * @param {function} props.onClick click handler
 */
export function IconButton(_ref, ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    onClick = _ref.onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    attrs = _objectWithoutProperties(_ref, ["children", "className", "onClick", "disabled"]);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    ref: ref,
    className: className,
    modifier: "icon",
    onClick: onClick,
    disabled: disabled,
    wrap: false
  }, attrs), /*#__PURE__*/React.createElement(ButtonWrapper, {
    modifier: "icon",
    disabled: disabled,
    className: styles.icon
  }, children));
}
var Component = React.forwardRef(IconButton);
Component.displayName = 'IconButton';
export default Component;